<template>
  <textarea
    v-model="text"
    :placeholder="placeholder"
    class="reason-text-area"
    @input="emitChange"
  ></textarea>
</template>

<script>
export default {
  name: "ReasonTextArea",
  props: { placeholder: { type: String, default: "Start typing" } },
  data() {
    return {
      text: "",
    };
  },
  methods: {
    emitChange() {
      this.$emit("textChange", this.text);
    },
  },
};
</script>

<style scoped>
.reason-text-area {
  height: 109px;
  background: #ffffff;
  border: 0.8px solid #dbdbdb;
  box-sizing: border-box;
  border-radius: 1.6px;
  width: 100%;
  resize: none;
  padding: 28px 25px 27px 25px;
}
</style>
